// GENERATED CODE - DO NOT EDIT
export const OrderBundlingOriginMap = {
    ENTER_CHECKOUT: 'enter_checkout',
    CHECKOUT: 'checkout',
    EDIT_ORDER: 'edit_order',
    AUTO_REFILL: 'auto_refill',
};
//# sourceMappingURL=order_bundling_origin.js.map